import React from "react";
import { Link } from "react-router-dom";
import mainLogo from "../Assets/main-logo.png"
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";




const Navbar = () => {
  return (
    <>
      <nav className="navbar navbar-chang navbar-expand-lg d-none d-lg-flex">
        <div className="container position-re">

          <div className="row d-flex justify-content-center custom-main-navbar">
            <div className="col-lg-2 col-2 order1">
              <div className="bord">
                <Link className="logo icon-img-70" to="/">
                  <img src={mainLogo} alt="MaheebK" />
                </Link>
              </div>
            </div>
            <div className="col-lg-5 order3 col-6">
              <div className="bg">
                {/* navbar links */}
                <div className="full-width">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link className="nav-link" to="/">
                        <span className="rolling-text">
                          <div className="block">
                            <span className="letter">H</span>
                            <span className="letter">o</span>
                            <span className="letter">m</span>
                            <span className="letter">e</span>
                          </div>
                          <div className="block">
                            <span className="letter">H</span>
                            <span className="letter">o</span>
                            <span className="letter">m</span>
                            <span className="letter">e</span>
                          </div>
                        </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about">
                        <span className="rolling-text">
                          <div className="block">
                            <span className="letter">A</span>
                            <span className="letter">b</span>
                            <span className="letter">o</span>
                            <span className="letter">u</span>
                            <span className="letter">t</span>
                          </div>
                          <div className="block">
                            <span className="letter">A</span>
                            <span className="letter">b</span>
                            <span className="letter">o</span>
                            <span className="letter">u</span>
                            <span className="letter">t</span>
                          </div>
                        </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact">
                        <span className="rolling-text">
                          <div className="block">
                            <span className="letter">S</span>
                            <span className="letter">e</span>
                            <span className="letter">r</span>
                            <span className="letter">v</span>
                            <span className="letter">i</span>
                            <span className="letter">c</span>
                            <span className="letter">e</span>
                            <span className="letter">s</span>
                          </div>
                          <div className="block">
                            <span className="letter">S</span>
                            <span className="letter">e</span>
                            <span className="letter">r</span>
                            <span className="letter">v</span>
                            <span className="letter">i</span>
                            <span className="letter">c</span>
                            <span className="letter">e</span>
                            <span className="letter">s</span>
                          </div>
                        </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="">
                        <span className="rolling-text">
                          <div className="block">
                            <span className="letter">P</span>
                            <span className="letter">r</span>
                            <span className="letter">o</span>
                            <span className="letter">j</span>
                            <span className="letter">e</span>
                            <span className="letter">c</span>
                            <span className="letter">t</span>
                            <span className="letter">s</span>
                          </div>
                          <div className="block">
                            <span className="letter">P</span>
                            <span className="letter">r</span>
                            <span className="letter">o</span>
                            <span className="letter">j</span>
                            <span className="letter">e</span>
                            <span className="letter">c</span>
                            <span className="letter">t</span>
                            <span className="letter">s</span>
                          </div>
                        </span>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <a className="nav-link" href="blogs.html">
                        <span className="rolling-text">
                          <div className="block">
                            <span className="letter">B</span>
                            <span className="letter">l</span>
                            <span className="letter">o</span>
                            <span className="letter">g</span>
                          </div>
                          <div className="block">
                            <span className="letter">B</span>
                            <span className="letter">l</span>
                            <span className="letter">o</span>
                            <span className="letter">g</span>
                          </div>
                        </span>
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact">
                        <span className="rolling-text">
                          <div className="block">
                            <span className="letter">C</span>
                            <span className="letter">o</span>
                            <span className="letter">n</span>
                            <span className="letter">t</span>
                            <span className="letter">a</span>
                            <span className="letter">c</span>
                            <span className="letter">t</span>
                          </div>
                          <div className="block">
                            <span className="letter">C</span>
                            <span className="letter">o</span>
                            <span className="letter">n</span>
                            <span className="letter">t</span>
                            <span className="letter">a</span>
                            <span className="letter">c</span>
                            <span className="letter">t</span>
                          </div>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-3 order2">
              <div className="bord d-flex justify-content-start">
                <ul className="social d-flex rest">
                  <li>
                    <Link to="https://x.com/KhanMahebullah?t=OAf4tjESBQr1y-m-p7p0cQ&s=09">
                      <FaXTwitter />
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.instagram.com/gulam_khan_14?igsh=bWI0NXNyYXVleGZq">
                      <BsInstagram />
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.linkedin.com/in/maheeb2000">
                      <FaLinkedin />
                    </Link>
                  </li>
                </ul>
                <button className="navbar-toggler" type="button">
                  <span className="icon-bar">
                    <i className="fas fa-bars" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <nav className="navbar navbar-expand-lg mobile-navbar d-lg-none d-flex">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/" >
            <img src={mainLogo} alt="MaheebK" />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  <span className="rolling-text">
                    <div className="block">
                      <span className="letter">H</span>
                      <span className="letter">o</span> 
                      <span className="letter">m</span>
                      <span className="letter">e</span>
                    </div>
                    <div className="block">
                      <span className="letter">H</span>
                      <span className="letter">o</span>
                      <span className="letter">m</span>
                      <span className="letter">e</span>
                    </div>
                  </span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  <span className="rolling-text">
                    <div className="block">
                      <span className="letter">A</span>
                      <span className="letter">b</span>
                      <span className="letter">o</span>
                      <span className="letter">u</span>
                      <span className="letter">t</span>
                    </div>
                    <div className="block">
                      <span className="letter">A</span>
                      <span className="letter">b</span>
                      <span className="letter">o</span>
                      <span className="letter">u</span>
                      <span className="letter">t</span>
                    </div>
                  </span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link">
                  <span className="rolling-text">
                    <div className="block">
                      <span className="letter">S</span>
                      <span className="letter">e</span>
                      <span className="letter">r</span>
                      <span className="letter">v</span>
                      <span className="letter">i</span>
                      <span className="letter">c</span>
                      <span className="letter">e</span>
                      <span className="letter">s</span>
                    </div>
                    <div className="block">
                      <span className="letter">S</span>
                      <span className="letter">e</span>
                      <span className="letter">r</span>
                      <span className="letter">v</span>
                      <span className="letter">i</span>
                      <span className="letter">c</span>
                      <span className="letter">e</span>
                      <span className="letter">s</span>
                    </div>
                  </span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/projects">
                  <span className="rolling-text">
                    <div className="block">
                      <span className="letter">P</span>
                      <span className="letter">r</span>
                      <span className="letter">o</span>
                      <span className="letter">j</span>
                      <span className="letter">e</span>
                      <span className="letter">c</span>
                      <span className="letter">t</span>
                      <span className="letter">s</span>
                    </div>
                    <div className="block">
                      <span className="letter">P</span>
                      <span className="letter">r</span>
                      <span className="letter">o</span>
                      <span className="letter">j</span>
                      <span className="letter">e</span>
                      <span className="letter">c</span>
                      <span className="letter">t</span>
                      <span className="letter">s</span>
                    </div>
                  </span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  <span className="rolling-text">
                    <div className="block">
                      <span className="letter">C</span>
                      <span className="letter">o</span>
                      <span className="letter">n</span>
                      <span className="letter">t</span>
                      <span className="letter">a</span>
                      <span className="letter">c</span>
                      <span className="letter">t</span>
                    </div>
                    <div className="block">
                      <span className="letter">C</span>
                      <span className="letter">o</span>
                      <span className="letter">n</span>
                      <span className="letter">t</span>
                      <span className="letter">a</span>
                      <span className="letter">c</span>
                      <span className="letter">t</span>
                    </div>
                  </span>
                </Link>
              </li>

            </ul>
            <ul className="social d-flex rest">
                  <li>
                    <Link to="https://x.com/KhanMahebullah?t=OAf4tjESBQr1y-m-p7p0cQ&s=09">
                      <FaXTwitter />
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.instagram.com/gulam_khan_14?igsh=bWI0NXNyYXVleGZq">
                      <BsInstagram />
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.linkedin.com/in/maheeb2000">
                      <FaLinkedin />
                    </Link>
                  </li>
            </ul>
          </div>
        </div>
      </nav>

    </>
  );
};

export default Navbar;
